import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

type PermissionProps = {
  label: string;
  value: number;
};

@Component({
  selector: 'app-permission-tree',
  templateUrl: './permission-tree.component.html',
  styleUrls: ['./permission-tree.component.scss'],
})
export class PermissionTreeComponent implements OnChanges {
  @Input() permissions: any[] = [];
  @Input() level: number = 0;
  @Input() selectedPermissions: PermissionProps[] = [];
  @Input() readOnly: boolean = false;

  @Output() permissionChange = new EventEmitter<number>();

  expandedIds: Set<number> = new Set<number>();
  @Input() baseData: any[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['permissions'] && this.permissions) {
      //   this.expandAllWithChildren(this.permissions);
    }
  }

  toggleExpand(id: number): void {
    this.expandedIds.has(id)
      ? this.expandedIds.delete(id)
      : this.expandedIds.add(id);
  }

  isExpanded(id: number): boolean {
    return this.expandedIds.has(id);
  }

  onPermissionToggle(id: number): void {
    this.permissionChange.emit(id);
  }

  isChecked(id: number): boolean {
    return this.selectedPermissions?.some((p) => p.value === id);
  }

  private expandAllWithChildren(permissions: any[]): void {
    for (const perm of permissions) {
      if (perm.children?.length) {
        this.expandedIds.add(perm.id);
        this.expandAllWithChildren(perm.children);
      }
    }
  }

  getAllDescendants(node: any): any[] {
    let descendants: any[] = [];
    if (node.children && node.children.length > 0) {
      node.children.forEach((child: any) => {
        descendants.push(child);
        descendants = descendants.concat(this.getAllDescendants(child));
      });
    }
    return descendants;
  }

  onTogglePermission(node: any): void {
    const isChecked = this.isSelected(node.id);
    const descendants = this.getAllDescendants(node);

    // Atualiza estado do nó clicado
    this.permissionChange.emit(node.id);

    // Marca ou desmarca os filhos
    descendants.forEach((child) => {
      const childChecked = this.isSelected(child.id);
      if (isChecked && childChecked) {
        this.permissionChange.emit(child.id); // desmarca
      }
      if (!isChecked && !childChecked) {
        this.permissionChange.emit(child.id); // marca
      }
    });

    // Verifica e atualiza os pais depois de qualquer mudança
    this.updateParentSelection(node);
  }

  updateParentSelection(node: any): void {
    if (!node.parent_permission) return;

    const parentId = node.parent_permission.id;
    const parent = this.findPermissionById(parentId, this.permissions);
    if (!parent) return;

    const allChildrenSelected = parent.children?.every((child) =>
      this.selectedPermissions.some((p) => p.value === child.id)
    );

    const parentIsSelected = this.selectedPermissions.some(
      (p) => p.value === parentId
    );

    if (allChildrenSelected && !parentIsSelected) {
      this.permissionChange.emit(parentId); // Marca o pai
      this.updateParentSelection(parent); // Sobe mais
    }

    if (!allChildrenSelected && parentIsSelected) {
      this.permissionChange.emit(parentId); // Desmarca se algum filho saiu
    }
  }

  isSelected(id: number): boolean {
    return this.selectedPermissions.some((p) => p.value === id);
  }

  findPermissionById(id: number, list: any[]): any | null {
    for (const item of list) {
      if (item.id === id) return item;
      if (item.children) {
        const found = this.findPermissionById(id, item.children);
        if (found) return found;
      }
    }
    return null;
  }

  isHeader(id: any) {
    return this.baseData.find((item) => item.id === id)?.header === true;
  }
}
